/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type PatchTherapistSetupIntentPayload = {
    intendedMeetingProvider?: string | null;
    meetingConnectDeclined?: boolean;
    intendedCalendarProvider?: string | null;
    calendarConnectDeclined?: boolean;
    widgetIntent?: PatchTherapistSetupIntentPayload.widgetIntent | null;
    bookingSiteIntent?: PatchTherapistSetupIntentPayload.bookingSiteIntent | null;
    clientPortalIntent?: PatchTherapistSetupIntentPayload.clientPortalIntent | null;
    paymentMethodSetupPending?: boolean;
    accountingConnectSetupPending?: boolean;
    /**
     * Append a finished optional feature wizard id (paymentsAndAccounting, documentation, emailCustomization)
     */
    addCompletedFeatureWizardId?: string;
};
export namespace PatchTherapistSetupIntentPayload {
    export enum widgetIntent {
        YES = 'yes',
        NO = 'no',
        LATER = 'later',
    }
    export enum bookingSiteIntent {
        YES = 'yes',
        NO = 'no',
    }
    export enum clientPortalIntent {
        YES = 'yes',
        NO = 'no',
        AUTO = 'auto',
    }
}

